// ════════════════════════════════════════════════════════════════════════
//  Ankommen heißt: das Feld ist zu sehen und hat den Fokus
//
//  Ein Link auf `#stufe-grundreihe-4a.stufe-1` bringt einen an die richtige
//  Karte – und dann sucht man das Feld. Der Sprung ist erst dann eine Hilfe,
//  wenn der Cursor schon dort steht, wo getippt werden muss.
//
//  Warum nicht der eingebaute Ankersprung des Browsers: React Router rendert
//  das Ziel erst nach dem Adresswechsel. Zum Zeitpunkt des Sprungs gibt es das
//  Element noch nicht.
// ════════════════════════════════════════════════════════════════════════

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useAnchorFocus(): void {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) return;
    // Anker enthalten Stufenschlüssel mit Punkten – die sind in einem
    // CSS-Selektor Klassentrenner. getElementById kennt das Problem nicht.
    const id = decodeURIComponent(hash.slice(1));
    const target = document.getElementById(id);
    if (!target) return;

    target.scrollIntoView({ block: "center" });

    const field = target.matches("input, textarea, select")
      ? target
      : target.querySelector<HTMLElement>("input, textarea, select");
    field?.focus({ preventScroll: true });
  }, [hash, pathname]);
}
